// services/companyService.js
import { companiesAPI } from './api';

export const companyService = {
  async getCompanies() {
    try {
      const response = await companiesAPI.getAll();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching companies:', error);
      throw new Error(error.response?.data?.message || 'Failed to load companies');
    }
  },

  async getCompany(id) {
    try {
      const response = await companiesAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching company:', error);
      throw new Error(error.response?.data?.message || 'Failed to load company');
    }
  },

  async createCompany(company) {
    try {
      console.log('📤 Creating company:', company);
      const response = await companiesAPI.create(company);
      console.log('✅ Company created:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating company:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to create company';
      throw new Error(errorMessage);
    }
  },

  async updateCompany(id, company) {
    try {
      console.log(`📤 Updating company ${id}:`, company);
      const response = await companiesAPI.update(id, company);
      console.log('✅ Company updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating company:', error);
      const errorMessage = error.response?.data?.title || 
                          error.response?.data?.message || 
                          error.response?.data || 
                          'Failed to update company';
      throw new Error(errorMessage);
    }
  },

  async deleteCompany(id) {
    try {
      await companiesAPI.delete(id);
    } catch (error) {
      console.error('❌ Error deleting company:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete company');
    }
  }
};